import React, {Component} from 'react';
import {Link, Redirect} from 'react-router-dom';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import api from '../../../helpers/api';
import {getTranslate} from 'react-localize-redux';
import {loadLanguage} from '../../../common/redux/localeReducer';
import {notifySuccess, notifyError} from '../../../common/redux/notificationReducer';
import {forgotPasswordNewRules} from '../rules';
import forgotPassword from '../locales/forgotPassword.json';
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css';
import {Error, Input} from "../../../common/components/form";
import Validator from "validatorjs";

class ForgotPasswordNewForm extends Component {
	constructor(props) {
		super(props);

		const {loadLanguage} = props;
		loadLanguage(forgotPassword);

		this.state = {
			isLoading: false,
			redirectTo: false,
			forgotPasswordForm: {
				isPasswordResetByEmail: false,
				email: '',
				mobile: ''
			},
			errors: {}
		}
	}

	formSubmit = async (e) => {
		e.preventDefault();
		const {forgotPasswordForm} = this.state;

		let validation = new Validator(forgotPasswordForm, forgotPasswordNewRules.validators, forgotPasswordNewRules.messages);

		if(await validation.fails()) {
			return this.setState({errors: validation.errors.all()});
		}

		this.setState({errors: {}});
		return this.handleSubmit(forgotPasswordForm);
	};

	updateState = (object) => {
		this.setState(state => ({
			forgotPasswordForm: {
				...state.forgotPasswordForm,
				...object
			}
		}))
	};

	handleSubmit = async (values) => {
		const {notifySuccess, notifyError} = this.props;
		try {
			const response = await api.post('/auth/forgot-password', values);
			notifySuccess(response.message);

			this.setState({ ...this.state, redirectTo: true});
		} catch (error) {
			notifyError(error.message);
		}
	};

	render() {
		const {translate} = this.props;
		const {errors, forgotPasswordForm, redirectTo, isLoading} = this.state;

		if (redirectTo) {
			return <Redirect to='/auth/login' />;
		}

		const loading = (
			<div className="overlay">
				<i className="fa fa-refresh fa-spin"/>
			</div>
		);

		const content = (
			<div className="login-box-body box">
				<p className="login-box-msg">{translate('forgot_password_page_title')}</p>

				<form onSubmit={this.formSubmit}>
					{forgotPasswordForm.isPasswordResetByEmail
						? <div className="form-group" style={{marginBottom: '4px'}}>
							<Input placeholder={translate('forgot_password_email_placeholder')} value={forgotPasswordForm.email} onChange={e => this.updateState({email: e.target.value})} />
							{errors.email && <Error text={translate(errors.email[0])} />}
						</div>
						: <div className="form-group" style={{marginBottom: '4px'}}>
							<PhoneInput
								inputStyle={{width: '100%'}}
								country='us'
								enableSearch={true}
								masks={{bd: '.... ......'}}
								placeholder="Mobile"
								value={forgotPasswordForm.mobile}
								onChange={value => this.updateState({mobile: value})}
							/>
							{errors.mobile && <Error text={translate(errors.mobile[0])} />}
						</div>}
					<div className='text-left' style={{
						fontWeight: 700,
						marginBottom: '16px',
						display: 'inline-block',
						fontSize: '12px'
					}}>
						{forgotPasswordForm.isPasswordResetByEmail
							? <a href='#!' onClick={() => this.updateState({isPasswordResetByEmail: false})}>
								{translate('forgot_password_reset_password_by_mobile')}
							</a>
							: <a href='#!' onClick={() => this.updateState({isPasswordResetByEmail: true})}>
								{translate('forgot_password_reset_password_by_email')}
							</a>}
					</div>

					<div className="row">
						<div className="col-xs-12 text-center">
							{
								isLoading ?	loading : (
									<button type="submit" className="btn btn-primary btn-inverse">
										{translate('forgot_password_submit_text')}
									</button>
								)
							}
						</div>
					</div>
				</form>

				<div className="social-auth-links text-center">
					<Link to="/auth/login">
						{translate('forgot_password_login_title')}
					</Link>
				</div>
			</div>
		);

		return translate('forgot_password_page_title') ? content : <div className="login-box-body box">{ loading }</div>;
	}
}

const mapStateToProps = state => ({
	translate: getTranslate(state.locale)
});

const mapDispatchToProps = dispatch => bindActionCreators({
	loadLanguage,
	notifySuccess,
	notifyError
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordNewForm);